export { default } from './EmbedImage'
